// The engine's 500 body echoes the failing OQL in `stack` (verified against the local engine on
// 127.0.0.1:3001: the write query's `"login-secret" "<value>"` appears verbatim). writeLlmLogin
// puts the pasted Claude token in that query, so a failed write must be scrubbed before the body
// reaches Sentry (src/api.tsx) or an error message the screen shows.
export const REDACTED = "[redacted]";

const LOGIN_SECRET_PAIR = /("login-secret"\s*)"(?:[^"\\]|\\.)*"/g;
const ANTHROPIC_TOKEN = /sk-ant-[A-Za-z0-9_-]{8,}/g;

export const redactText = (text: string): string =>
  text.replace(LOGIN_SECRET_PAIR, `$1"${REDACTED}"`).replace(ANTHROPIC_TOKEN, REDACTED);

// Keep the error code/type: only string values are rewritten.
export const redactApiErrorBody = <T>(body: T): T => {
  if (typeof body === "string") return redactText(body) as unknown as T;
  if (Array.isArray(body)) return body.map((item) => redactApiErrorBody(item)) as unknown as T;
  if (body && typeof body === "object") {
    const out: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(body as Record<string, unknown>)) {
      out[key] = redactApiErrorBody(value);
    }
    return out as T;
  }
  return body;
};
